var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#183238",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 1.333
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.605 8.778v2.37c0 .655-.528 1.185-1.179 1.185H1.178c-.65 0-1.178-.53-1.178-1.185v-2.37",
    transform: "translate(.587 .667) translate(2.651 1)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.891 2.963L2.946 0 0 2.963",
    transform: "translate(.587 .667) translate(2.651 1) matrix(1 0 0 -1 2.357 9.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.946 1.185L2.946 8.296",
    transform: "translate(.587 .667) translate(2.651 1) matrix(1 0 0 -1 2.357 9.667)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H15.907V16H0z",
    transform: "translate(.587 .667)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.24b59e30ae10e54ad37d71cb04ff7a4d.svg";
export { ForwardRef as ReactComponent };